<script setup>
import { useAuthStore } from '~/auth/stores/auth.store';
import { useCommonImports } from '~/common/composables/common-imports.composable.js';

const { $t, route, auth_store } = useCommonImports();
const { show_audit_logs } = useAuthStore();

const sidebar_top_items = computed(() => [
  {
    uid: 'general',
    label: $t('General'),
    to: { name: !route?.params?.asset_id ? 'account-settings-general' : 'account-settings-asset-general' },
    icon: IconHawkSettingsOne,
  },
  {
    uid: 'users',
    label: $t('Users'),
    to: { name: 'account-settings-users' },
    icon: IconHawkUserOne,
  },
  {
    uid: 'teams',
    label: $t('Teams'),
    to: { name: 'account-settings-teams' },
    icon: IconHawkUsersOne,
  },
  {
    uid: 'roles',
    label: $t('Roles'),
    to: { name: 'account-settings-roles' },
    icon: IconHawkUserSquare,
  },
  ...(!route?.params?.asset_id
    ? [{
        uid: 'categories',
        label: $t('Categories & Tags'),
        to: { name: 'account-settings-categories' },
        icon: IconHawkLayoutGridOne,
      }]
    : [{
        uid: 'categories',
        label: $t('Categories'),
        to: { name: 'account-settings-asset-categories' },
        icon: IconHawkLayoutGridOne,
      }]),
  ...(!route?.params?.asset_id
    ? [{
        uid: 'asset_settings',
        label: $t('Asset properties'),
        to: { name: 'account-settings-asset-fields' },
        icon: IconHawkLayersTwoTwo,
      }, {
        uid: 'integrations',
        label: $t('Integrations'),
        to: { name: 'account-settings-integrations' },
        icon: IconHawkLinkFour,
      }, ...(show_audit_logs
        ? [{
            uid: 'audit_logs',
            label: $t('Audit logs'),
            to: { name: 'account-settings-audit-logs' },
            icon: IconHawkLogInOne,
          }]
        : [])]
    : []),
  ...((auth_store.is_hacker_user || auth_store.is_manager_team_user)
    ? [{
        uid: 'apps',
        label: $t('Apps'),
        to: { name: 'account-settings-apps-perms' },
        icon: IconHawkMonitorOne,
      }]
    : []),
  ...(!route?.params?.asset_id && auth_store.is_hacker_user
    ? [{
        uid: 'apps',
        label: 'Data warehouse',
        to: { name: 'account-settings-data-warehouse-settings' },
        icon: IconHawkDatabaseTwo,
      }]
    : []),
]);
</script>

<template>
  <div class="flex">
    <HawkSidebarNavigation :sidebar_top_items="sidebar_top_items" />
    <div class="w-[calc(100vw-80px)] flex-1 pl-20 relative mx-4">
      <RouterView />
    </div>
  </div>
</template>
